export default "__VITE_ASSET__qMeSiWBGwzNgVqbXM54vzQ__";